import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/privacy-policy.css';

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Mauli Cabs</title>
        <meta name="description" content="Read the Privacy Policy of Mauli Cabs, understand how we collect and protect your data, and learn about your rights." />
      </Helmet>

   


      <section
  className="vs-breadcrumb"
  style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
>
  

  <div className="container">
    <div className="row text-center">
      <div className="col-12">
        <div className="breadcrumb-content">
          <h1 className="breadcrumb-title">Privacy Policy</h1>
        </div>
      </div>
    </div>
  </div>
</section>

      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">
            <div className="col-12 col-md-7">
              <h3 className="title">Privacy Policy</h3>

              <p>
                At Mauli Cabs, your privacy is extremely important to us. This Privacy Policy explains what data we collect, how we use it, and the steps we take to protect your information.
              </p>

              <div className="section">
                <p className="highlight darkcolor">Information We Collect:</p>
                <p className="highlight darkcolor">1. Personal Information:</p>
                <p>
                  We collect your name, phone number, email address, and payment details to ensure smooth cab booking services.
                </p>

                <p className="highlight darkcolor">2. Usage Data:</p>
                <p>
                  We gather technical information such as IP address, device type, and browsing activity to enhance our services.
                </p>

                <p className="highlight darkcolor">3. Location Data:</p>
                <p>
                  With your consent, we collect location information to provide accurate ride services and improve user experience.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">How We Use Your Information:</p>
                <p className="highlight darkcolor">1. Service Delivery:</p>
                <p>
                  Your details are used for confirming bookings, tracking rides, and processing payments securely.
                </p>

                <p className="highlight darkcolor">2. Platform Improvement:</p>
                <p>
                  We use feedback and usage patterns to enhance our website, mobile application, and services.
                </p>

                <p className="highlight darkcolor">3. Communication:</p>
                <p>
                  We may contact you regarding ride updates, service notifications, and account-related information.
                </p>

                <p className="highlight darkcolor">4. Marketing & Promotions:</p>
                <p>
                  With your permission, we send special offers, promotions, and important service updates.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Information Sharing:</p>
                <p className="highlight darkcolor">1. Service Providers:</p>
                <p>
                  We may share necessary information with trusted third-party service providers for payment processing, customer support, and other operational purposes.
                </p>

                <p className="highlight darkcolor">2. Legal Requirements:</p>
                <p>
                  We may disclose your information if required by law, or to protect our rights and ensure the safety of our users.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Data Security:</p>
                <p>
                  We implement industry-standard security measures to protect your personal information. However, no electronic transmission is 100% secure.
                </p>

                <p className="highlight darkcolor">Your Rights:</p>
                <p>
                  You have the right to access, modify, or delete your personal information. You can also opt-out of receiving marketing communications at any time.
                </p>

                <p className="highlight darkcolor">Policy Updates:</p>
                <p>
                  Mauli Cabs may update this Privacy Policy from time to time. We encourage you to review this page periodically for the latest information.
                </p>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>For any questions or concerns regarding this Privacy Policy, please contact us:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+917972733209">+91 7972733209</a></li>
              <li><b>Email:</b> <a href="mailto:booking@maulicab.com">booking@maulicab.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
